import './ApiKeyComponent.scss';
import { Component } from "react";
import { ApiKeysContext } from "./ApiKeysContext";
import ApiKeysTable from "./ApiKeysTable/ApiKeysTableComponent";
import { BlockUi } from 'app/components/Basics/';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import {ShowError, ShowSuccess} from "../toast";
import GetErrorMessage from 'app/helpers/error-message';

class ApiKeysMangement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            errorMessage: null,
            apiKeys: [],
            uiBlocked: false,
        };
    }

    async componentDidMount() {
        await this.updateView();
        this.setState({ loading: false, uiBlocked: false });
    }

    async updateView() {
        try {
            var apiKeys = await this.fetchAllApiKeys();
            this.setState({
                apiKeys: apiKeys
            });
        } catch (error) {
            this.setState({ errorMessage: GetErrorMessage(error) });
            return null;
        }
    }

    async updateSelectedApiKeyHandler(apiKey) {
        this.setState({ selectedApiKey: apiKey })
    }

    async createApiKeyHandler(apiKey) {
        try {
            var createdKey = await this.createApiKey(apiKey);
        } catch (error) {
            this.setState({ errorMessage: GetErrorMessage(error) });
            return null;
        }
        await this.updateView();
        this.setState({ successMessage: "API key created successfully." });    
        return createdKey;
    }

    async updateApiKeyHandler(apiKey) {
        try {
            await this.updateApiKey(apiKey);
        } catch (error) {
            this.setState({ errorMessage: GetErrorMessage(error) });
            return null;
        }
        this.setState({ successMessage: "API key updated successfully." });
        await this.updateView();
    }

    async deleteApiKeyHandler(apiKeyId) {
        try {
            await this.deleteApiKey(apiKeyId);
        } catch (error) {
            this.setState({ errorMessage: GetErrorMessage(error) });
            return null;
        }
        this.setState({ successMessage: "API key deleted successfully." });
        await this.updateView();
    }

    //overridden by the parent component
    async fetchAllApiKeys() {
        // Expected to be overridden by the parent component
        // return AwsApiKeys[];
        throw new Error("fetchAllKeys method must be implemented by the parent component");
    }

    async createApiKey(apiKey) {
        // Expected to be overridden by the parent component
        // return AwsApiKey;
        throw new Error("createApiKey method must be implemented by the parent component");
    }

    async updateApiKey(apiKey) {
        // Expected to be overridden by the parent component
        throw new Error("updateApiKey method must be implemented by the parent component");
    }

    async deleteApiKey(apiKeyId) {
        // Expected to be overridden by the parent component
        throw new Error("deleteApiKey method must be implemented by the parent component");
    }

    render() {
        return (
            <BlockUi blocking={this.state.uiBlocked}>
                <main className="app-body">
                    <ApiKeysContext.Provider value={
                        {
                            updateSelectedApiKey: this.updateSelectedApiKeyHandler.bind(this),
                            updateApiKey: this.updateApiKeyHandler.bind(this),
                            createApiKey: this.createApiKeyHandler.bind(this),
                            deleteApiKey: this.deleteApiKeyHandler.bind(this),
                            selectedApiKey: this.state.selectedApiKey
                        }
                    }>
                        <div className="app-content scrollbox">
                            <div className="AppFormComponent">
                                <div className='apiKeysList'>
                                    <div className="GlobalControlLineComponent form-row">
                                        <div className="IntroHeader">
                                            {this.state.header}
                                        </div>
                                    </div>
                                    <Card>
                                        <ApiKeysTable apiKeys={this.state.apiKeys} />
                                    </Card>
                                </div>
                            </div>
                        </div>
                        {this.state.successMessage && (<ShowSuccess clearMessage={() => this.setState({ successMessage: '' })} message={this.state.successMessage} />)}
                        {this.state.errorMessage && (<ShowError clearErrorMessage={() => this.setState({ errorMessage: '' })} errorMessage={this.state.errorMessage} />)}
                    </ApiKeysContext.Provider>
                </main>
            </BlockUi>
        );
    }
}

export default ApiKeysMangement;